module.exports = __webpack_public_path__ + "static/we-do-en-7fc2b5f680e2007a2e010c78f543e23a.gif";